import { Alert, Snackbar, useTheme } from '@mui/material';
import React from 'react';
import { motion } from 'framer-motion';

function CustomSnackBar({ setOpen, open, message, severity }) {
  const theme = useTheme();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  // Colores personalizados basados en el severity
  const getBackgroundColor = () => {
    switch (severity) {
      case 'error':
        return theme.palette.error.dark;
      case 'warning':
        return theme.palette.warning.dark;
      case 'success':
        return theme.palette.success.dark;
      case 'info':
        return theme.palette.info.dark;
      default:
        return theme.palette.primary.dark;
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000} // 6 segundos (antes eran 3)
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} // Centrado
      TransitionComponent={(props) => (
        <motion.div
          {...props}
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 20, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 20 }}
        />
      )}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{
          width: '100%',
          maxWidth: '400px',
          borderRadius: '8px',
          boxShadow: theme.shadows[6],
          backgroundColor: getBackgroundColor(),
          '& .MuiAlert-icon': {
            fontSize: '1.25rem',
          },
          '& .MuiAlert-message': {
            fontWeight: 500,
          }
        }}
        iconMapping={{
          error: <span style={{ fontSize: '1.25rem' }}>⚠️</span>,
          warning: <span style={{ fontSize: '1.25rem' }}>⚠️</span>,
          info: <span style={{ fontSize: '1.25rem' }}>ℹ️</span>,
          success: <span style={{ fontSize: '1.25rem' }}>✓</span>,
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default CustomSnackBar;